import styled from 'styled-components';

import { breakpointsMax } from '../../../constants/breakPoints';

export const Main = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
`
